import { ALL_OPTION } from "constant";
import { useMemo } from "react";
import { useGetListBusinessPhoneNumber } from "service/query/business-management.query";

export const useListPhoneNumberByContactCenter = ({
  listProvince,
  contactCenter,
  callType,
}) => {
  const businessCode = useMemo(() => {
    if (contactCenter === ALL_OPTION.value) return ALL_OPTION.value;
    return listProvince?.find((item) => item.code === contactCenter)
      ?.businessCode;
  }, [contactCenter, listProvince]);

  const typeDial = useMemo(() => {
    if (callType === "inbound") return "in";
    if (callType === "outbound") return "out";
    if (callType === ALL_OPTION.value) return ALL_OPTION.value;
  }, [callType]);

  const { data: listPhoneNumber } = useGetListBusinessPhoneNumber();

  const listPhoneNumberByContactCenter = useMemo(() => {
    if (!listPhoneNumber) return [];
    return [
      ...new Set(
        listPhoneNumber
          .filter(
            (item) =>
              (businessCode === ALL_OPTION.value
                ? true
                : item.businessCode === businessCode) &&
              (typeDial === ALL_OPTION.value
                ? true
                : item.typeDial === typeDial)
          )
          .map((item) => item.phoneNumber)
      ),
    ];
  }, [businessCode, listPhoneNumber, typeDial]);

  return {
    listPhoneNumberByContactCenter,
  };
};
